import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import car from "../../../assest/images/Car.svg";
import bike from "../../../assest/images/Bike.svg";
import health from "../../../assest/images/Health.svg";
import accident from "../../../assest/images/Accident.svg";
import life from "../../../assest/images/Life.svg";
import travel from "../../../assest/images/Travel.svg";
import marine from "../../../assest/images/Marine.svg";
import renewal from "../../../assest/images/Renewal.svg";
import MaterialButton from "../../../components/MaterialButton";
import CloseIcon from "@mui/icons-material/Close";
import useStore from "../../../generalstore";
import insu from "../../../assest/Insurelogist 1.svg";

const insuranceData = [
  {
    title: "Soucient",
    image: car,
    route: "/products",
    isPermission: true,
  },
  {
    title: "General Health Insurance",
    image: insu,
    route: "/general",
    isPermission: false,
  },
];

const Products = () => {
  const navigate = useNavigate();
  const [alertIndex, setAlertIndex] = useState(null);
  const setProcess = useStore((state) => state.setProcess);
  const [open, setOpen] = useState(false);

  const handleCardClick = (item, index) => {
    if (item.isPermission) {
      setOpen(true);
    } else if (index == 1) {
      setProcess("general");
      navigate("/insurance");
    } else {
      setAlertIndex(index);
      setTimeout(() => setAlertIndex(null), 3000);
    }
  };

  const handleNavigateRollOver = () => {
    navigate("/products/roll-over");
  };
  const onCloseHandel = () => {
    setOpen(false);
  };
  useEffect(() => {
    setProcess("process");
  }, []);
  return (
    <DashboardLayout>
      <Grid2 container direction="row" spacing={2} padding={2}>
        {insuranceData.map((item, index) => (
          <Grid2 size={{ xs: 2, sm: 2, md: 2 }} key={index}>
            <Stack direction="column" spacing={1}>
              <Card
                onClick={() => handleCardClick(item, index)}
                sx={{
                  width: 150,
                  borderRadius: 3,
                  overflow: "hidden",
                  textAlign: "center",
                  bgcolor: "#f0f6ff",
                  cursor: "pointer",
                }}
              >
                <CardContent
                  sx={{ display: "flex", justifyContent: "center", py: 1 }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{ width: 80, height: 80, objectFit: "contain" }}
                  />
                </CardContent>
              </Card>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <MaterialTypography
                  variant="caption"
                  sx={{ fontWeight: 500, color: "dark", pb: 1 }}
                >
                  {item.title}
                </MaterialTypography>
              </Box>

              {alertIndex === index &&
                alert(
                  "You do not have the required permissions to access this page. Please contact your administrator."
                )}
            </Stack>
          </Grid2>
        ))}
      </Grid2>
      <Dialog
        open={open}
        onClose={onCloseHandel}
        PaperProps={{
          sx: {
            width: "420px",
            maxWidth: "100%",
            p: 2,
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "20px", color: "#1A1A1A" }}
        >
          Make your selection
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onCloseHandel}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <MaterialButton
              variant="contained"
              color="dark"
              onClick={() => navigate("/products/newCar")}
            >
              New car
            </MaterialButton>
            <MaterialButton
              variant="contained"
              color="dark"
              onClick={handleNavigateRollOver}
            >
              Roll over
            </MaterialButton>
          </div>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default Products;
